import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrBL: CultureInfo = {
  name: 'fr-BL',
  displayName: 'français (Saint-Barthélemy)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-BL',
  parent: CultureInfoFr
};
